module.exports = __webpack_public_path__ + "img/gb13871-92_95x120x12.prt.7cc6e97b.jpg";